import { IEnrichedEvent } from '@bridebook/web/components/wedding-website/guest-rsvp/guest-rsvp.context';
import { TFunction } from 'next-i18next';

const getEventDetailsCaption = (event: IEnrichedEvent, t: TFunction) => {
  const { data, supplier } = event;

  const startTime = data?.time?.startTime;
  const endTime = data?.time?.endTime;

  const hasSupplier = Boolean(supplier);
  const hasStartTime = Boolean(startTime);
  const hasEndTime = Boolean(endTime) && hasStartTime;

  if (hasSupplier && hasEndTime) {
    return t('weddingWebsite:rsvp.events.eventDetailsCaption.allDetails', {
      startTime,
      endTime,
      supplierName: supplier?.name,
    });
  }

  if (hasStartTime && hasSupplier) {
    return t('weddingWebsite:rsvp.events.eventDetailsCaption.supplierAndStartTimeDetails', {
      startTime,
      supplierName: supplier?.name,
    });
  }

  if (hasEndTime) {
    return t('weddingWebsite:rsvp.events.eventDetailsCaption.timeOnlyDetails', {
      startTime,
      endTime,
    });
  }

  if (hasSupplier) {
    return t('weddingWebsite:rsvp.events.eventDetailsCaption.supplierOnlyDetails', {
      supplierName: supplier?.name,
    });
  }

  if (hasStartTime) return startTime;

  return '';
};

export default getEventDetailsCaption;
